
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bilingualism",
      function () {
        return require("private-next-pages/bilingualism/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bilingualism"])
      });
    }
  